import { RiskRegisters } from './settings/RiskRegisters'

// The screen 0045 shipped as "Send risks onward". A register is configured in
// one place now (Settings, Risk registers), and this route shows that same
// screen rather than a second copy of it, so a bookmark or the Risk menu still
// lands somewhere that works.
export function RiskSinks() {
  return (
    <div className="p1-page">
      <p className="muted">
        <a href="#/settings?t=registers">Settings</a>
      </p>
      <RiskRegisters standalone />
    </div>
  )
}
